import { render, staticRenderFns } from "./PriceRecord.vue?vue&type=template&id=48770078&scoped=true&"
import script from "./PriceRecord.vue?vue&type=script&lang=js&"
export * from "./PriceRecord.vue?vue&type=script&lang=js&"
import style0 from "./PriceRecord.vue?vue&type=style&index=0&id=48770078&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48770078",
  null
  
)

export default component.exports